import { createAction } from '@reduxjs/toolkit';

const toggleMenuModal = createAction('menuToggle/toggleMenuModal');
export default toggleMenuModal;
